import { PluginFunction } from "vue";
import Toaster from "./Toast.vue";
import { events } from "./events";

export interface ToastParams {
  id?: number
  title?: string
  text?: string
  state?: number
  group?: string
  clean?: boolean
  duration?: number
  type?: string
  speed?: number
  clear?: boolean
  data?: Record<string, any>
  timer?: number
  length?: number
}

export interface ToastOptions {
  name?: string
  componentName?: string
  velocity?: any
}

interface ToastFunction {
  (params: string | ToastParams): void
  close(id: string | number): void
}

const Toast: {
  install: PluginFunction<ToastOptions>
  installed?: boolean
  params?: ToastOptions
} = {
  install(VueInstance, args: ToastOptions = {}) {
    if (this.installed) return;
    
    this.installed = true;
    this.params = args
      
    VueInstance.component(args.componentName || "toaster", Toaster)
      
    const toast: ToastFunction = (params: string | ToastParams): void => {
      if (typeof params === 'string') {
        params = {title: "", text: params}
      }
        
      if (typeof params === "object") {
        events.$emit("add", params);
      }
    }
      
    toast.close = function(id) {
      events.$emit("close", id)
    }
      
    const name = args.name || "toast";
    (VueInstance.prototype as any)["$" + name] = toast;
    (VueInstance as any)[name] = toast;
  }
}

export default Toast
